import axios from "axios";
import { client } from "../client/client";

function getUserAgent() {
  return navigator.userAgent;
}
function getOrCreateDeviceId() {
  let id = localStorage.getItem("rehema_device_id");
  if (!id) {
    if (window.crypto?.randomUUID) {
      id = crypto.randomUUID();
    } else {
      id = ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
        (
          c ^
          (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
        ).toString(16),
      );
    }
    localStorage.setItem("rehema_device_id", id);
    document.cookie = `rehema_device_id=${id}; Max-Age=${
      60 * 60 * 24 * 365 * 5
    }; Path=/; SameSite=Lax`;
  }
  return id;
}

export const login = async (username, password) => {
  const response = await axios.post(
    `${process.env.REACT_APP_API_URL}api/v1/users/login`,
    {
      username,
      password,
      deviceId: getOrCreateDeviceId(),
      userAgent: getUserAgent(),
      platform: "web",
    },
  );

  return response.data;
};

export const setAuthPassword = async (id, password, current_password) => {
  const response = await client.patch(`api/v1/users/updatepassword/${id}`, {
    password,
    current_password,
  });

  return response?.data;
};

export const sendUserOtp = async (userId) => {
  const response = await client.post("api/v1/otp/user", {
    userId,
    isEmail: false,
  });

  return response?.data;
};

export const sendMemberOtp = async (userId) => {
  const response = await client.post("api/v1/otp", {
    userId,
    isEmail: false,
  });

  return response?.data;
};

export const sendEmailMemberOtp = async (userId) => {
  const response = await client.post("api/v1/otp", {
    userId,
    isEmail: true,
  });

  return response?.data;
};

export const verifyUserOtp = async (code, userId, email, phoneNumber) => {
  const response = await axios.post(
    `${process.env.REACT_APP_API_URL}api/v1/users/otp/verify-login`,
    {
      code,
      userId,
      deviceId: getOrCreateDeviceId(),
      isEmail: false,
      email,
      phoneNumber,
    },
  );

  return response.data;
};

export const verifyCustomerOtp = async (otp, phoneNumber) => {
  const response = await client.post("api/v1/otp/verify-otp", {
    otp,
    isEmail: false,
    phoneNumber,
  });

  return response?.data;
};

export const verifyEmailOtp = async (otp, email) => {
  const response = await client.post("api/v1/otp/verify-otp", {
    otp,
    isEmail: true,
    email,
  });

  return response?.data;
};

export const resetPassword = async (email) => {
  const response = await client.post("api/v1/users/resetpassword", {
    email,
  });

  return response?.data;
};


export const createBusinessAuditLog = async (payload) => {
  try {
    await client.post("/api/audit/business", payload);
  } catch (error) {
    console.error("Audit log failed:", error);
  }
};
